import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contextsKeys } from "Auth/Api/Queries/Context/useGetContextsQuery";
import {
  type CompleteRoleOnboardingResult,
  postIdentitiesRolesIdentityUserPublicIDComplete,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: CompleteRoleOnboardingResult) => void;
  onError?: () => void;
};

export const useCompleteRoleOnboardingMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (identityUserPublicID: string) =>
        postIdentitiesRolesIdentityUserPublicIDComplete(identityUserPublicID),
    ),
    onSuccess: (result: CompleteRoleOnboardingResult) => {
      queryClient.invalidateQueries({ queryKey: contextsKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
